import React from 'react';

import AssumptionsAdminContainer from './Container';
import { AssumptionsAdminProvider } from './Context';

const AssumptionsAdmin = () => {
  return (
    <AssumptionsAdminProvider>
      <AssumptionsAdminContainer />
    </AssumptionsAdminProvider>
  );
};

export default AssumptionsAdmin;
